export type TCustomer = {
  role: string;
  customerType: string;
  svocID: string;
  userID: string;
  email: string;
};

export type TCustomerType = 'B2B' | 'B2C';
export type TCustomerRole = 'ADMIN' | 'PURCHASER' | '';
export enum CustomerRole {
  ADMIN = 'ADMIN',
  PURCHASER = 'PURCHASER',
}
